import {
    Container,
    Row,
    Col,
    List,
    ListGroupItem
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Linkedin from '../../public/site-assets/svg/linkedin.svg'
import Facebook from '../../public/site-assets/svg/facebook.svg'
import Twitter from '../../public/site-assets/svg/twitter.svg'
import Instagram from '../../public/site-assets/svg/instagram.svg'

export default function SocialLinks({
    customClass = ""
}) {

    const router = useRouter();

    return (
        <div className={`${styles.root} ${customClass}`}>
            {router.asPath.startsWith("/us") ?  
            <List className="social-links-wrapper d-inline-flex flex-wrap gap-2 p-0 m-0">
                <ListGroupItem>
                    <Link href="https://www.linkedin.com/company/241214">
                        <a className="text-decoration-none" target="_blank" rel="noreferrer noopener" aria-label="Follow us on Linkedin">
                            <Linkedin />
                        </a>
                    </Link>
                </ListGroupItem>
            </List>
            :
            <List className="social-links-wrapper d-inline-flex flex-wrap gap-2 p-0 m-0">
                <ListGroupItem>
                    <Link href="https://www.linkedin.com/company/241214">
                        <a className="text-decoration-none" target="_blank" rel="noreferrer noopener" aria-label="Follow us on Linkedin">
                            <Linkedin />
                        </a>
                    </Link>
                </ListGroupItem>
                <ListGroupItem>
                    <Link href="https://twitter.com/SRGTalent">
                        <a className="text-decoration-none" target="_blank" rel="noreferrer noopener" aria-label="Follow us on Twitter">
                            <Twitter />
                        </a>
                    </Link>
                </ListGroupItem>
                <ListGroupItem>
                    <Link href="https://www.facebook.com/TalentSRG">
                        <a className="text-decoration-none" target="_blank" rel="noreferrer noopener" aria-label="Follow us on Facebook">
                            <Facebook />
                        </a>
                    </Link>
                </ListGroupItem>
                <ListGroupItem>
                    <Link href="https://www.instagram.com/srgtalent/">
                        <a className="text-decoration-none" target="_blank" rel="noreferrer noopener" aria-label="Follow us on Instagram">
                            <Instagram />
                        </a>
                    </Link>
                </ListGroupItem>
            </List>}
           
        </div>
    )
}